import { useMemo } from 'react';

import { ENDPOINTS } from './../../endpoints';
import { Service } from './../base';
import dynamicAxios from './../../utils/axios';
import { IndexStatus, IndexVariables, RestWorldRating, ShortenUrl } from './types';
import useServices from '../../hooks/useServices';

class ServiceGlobals extends Service {
  fetchVariableOptions(variableName: string | string[]) {
    let params;
    if (Array.isArray(variableName)) params = { variable_names: variableName };
    else params = { variable_name: variableName };

    return this.axiosInstance.get<IndexVariables>(ENDPOINTS.globals.variables, {
      params: params,
    });
  }

  fetchStatusOptions({ limit, offset, prefix }: { limit: number; offset: number; prefix: string }) {
    return this.axiosInstance.get<IndexStatus>(ENDPOINTS.globals.status, {
      params: { limit, offset, prefix },
    });
  }

  fetchRestworldRating() {
    return this.axiosInstance.get<RestWorldRating>(ENDPOINTS.globals.restworldRating);
  }
  compressImage(image: File, sizeThreshold: number) {
    const formData = new FormData();
    formData.append('image', image);
    formData.append('size_threshold', sizeThreshold.toString());
    return this.axiosInstance.post(ENDPOINTS.globals.compressImage, formData, {
      responseType: 'arraybuffer',
    });
  }

  createShortenUrl({ original_url }: { original_url: string }) {
    return this.axiosInstance.post<{
      data: {
        short_url: string;
      };
    }>(ENDPOINTS.globals.shortenUrl, {
      original_url,
    });
  }

  getShortenUrls({ limit, last_evaluated_key }: { limit?: number; last_evaluated_key?: string }) {
    return this.axiosInstance.get<{
      data: ShortenUrl[];
    }>(ENDPOINTS.globals.shortenUrl, {
      params: {
        limit,
        last_evaluated_key,
      },
    });
  }

  deleteShortenUrl(shortedUrlId: string) {
    return this.axiosInstance.delete<{
      data: { message: string };
    }>(`${ENDPOINTS.globals.shortenUrl}`, {
      data: {
        id: shortedUrlId,
      },
    });
  }

  unsubscribedEmails(email: string) {
    return this.axiosInstance.post(ENDPOINTS.globals.unsubscribedEmails, {
      email,
    });
  }
}

export const globalServices = ({ baseUrl, jwt }: { baseUrl: string; jwt?: string }) =>
  new ServiceGlobals(dynamicAxios(baseUrl, jwt));

export function useGlobalsService() {
  const { baseUrl, jwt } = useServices();
  return useMemo(() => new ServiceGlobals(dynamicAxios(baseUrl, jwt)), [baseUrl, jwt]);
}

export default useGlobalsService;

export * from './types';
